import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// Render the App component in the DOM
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('grid-item-1')
);
